<template>
 <div>
    <v-snackbar v-model="feedback.show" :color="feedback.color" top timeout="10000">
          <v-row justify="space-between">
            {{ feedback.text }}
              <div>
              <v-btn @click="hideFeedback" icon color="white">
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
              </div>
          </v-row>
     </v-snackbar>
 </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'snack bar',
  computed: {
    ...mapState(['feedback'])
  },
  data () {
    return {
    }
  },
  methods: {
    hideFeedback () {
      this.$store.commit('hideFeedback')
    }
  }
}
</script>
